import { PlayFab } from './PlayFab';
// const clientId = 'l2t5c8u25xyekg9ploc01l0d4js281';
const clientId = 'rsyvag0f9wd5ue8jbyz8836aqyc9f9';

export class Twitch {
  protected static accessToken:string = '';
  protected static chatSocket:WebSocket;

  public static setAccessToken(accessToken:string) {
    Twitch.accessToken = accessToken;
  }

  public static clearAccessToken() {
    Twitch.accessToken = '';
  }

  public static async getGameIdByName(name: string): Promise<string | null> {
    try {
      console.log('[Twitch] search categories', name);
      const result = await PlayFab.executeCloudScript('twitchSearchCategories', { query: name });
      console.log('[Twitch] search categories result', result);
      if (!result.success || !result.data || !result.data.success) return null;
      const helix = result.data.data; // Twitch Helix response
      if (helix && helix.data && helix.data.length > 0) {
        return helix.data[0].id;
      }
      return null;
    } catch {
      return null;
    }
  }

  public static async getStreams(gameId: string) {
    try {
      // Fetch via CloudScript (server holds token and client id)
      const result = await PlayFab.executeCloudScript('twitchGetStreamsNovaRally', { first: 50 });
      if (result.success && result.data && result.data.success) {
        return { success: true, body: result.data.data, aggregates: result.data.aggregates };
      } else {
        const err = (result.data && (result.data.reason || result.data.error)) || 'Unknown error';
        return { success: false, error: err, body: result.data && result.data.data ? result.data.data : {}, aggregates: result.data && result.data.aggregates ? result.data.aggregates : undefined };
      }
    } catch {
      return { success: false, body: {} };
    }
  }

  public static login() {
    let url = `https://id.twitch.tv/oauth2/authorize?response_type=token`;
    url += `&client_id=rsyvag0f9wd5ue8jbyz8836aqyc9f9`;
    url += `&redirect_uri=${window.location.origin}/twitch`;
    url += `&scope=`;
    window.location.href = url;
  }

  public static async getUser(): Promise<{success:boolean, body?:any, message?:string}> {
    return new Promise((resolve, reject) => {
      const url = `https://api.twitch.tv/helix/users`;
      var request = new XMLHttpRequest();
      request.open('GET', url);
      request.setRequestHeader('Authorization', `Bearer ${Twitch.accessToken}`);
      request.setRequestHeader('Client-ID', clientId); 

      console.log('> TWITCH /users');

      request.send();

      request.onload = () => {
        let body = JSON.parse(request.responseText);
        console.log('< TWITCH', body);
        
        if (request.status == 200) {
          resolve({ success: true, body });
        } else {
          resolve({ success: false, body });
        }
      };

      request.onerror = () => {
        reject({ success: false, message: "Network error" });
      };
    });
  }

  // Removed deprecated direct Helix call (getStream by user_login). All Helix calls now go through CloudScript.
}